import React from 'react'
import { HiddenContainer, Container, Box, Divider } from './styles'
import { isValidValue } from '../../../../../../../shared/utils/validates'
import { Grid } from '@material-ui/core'
import logoTmovPay from '../../../../../../../shared/assets/images/logoTmovPayGreen.svg'
import { format } from 'date-fns'
import { TextBoleto } from '../../../../PagamentoBoleto/components/DetalhePagamentoBoleto/styles'
import { colors } from '../../../../../../../shared/styles/colors'
import { numberToCurrency } from '../../../../../../../shared/utils/formatters'
import { useCartao } from '../../../../../hooks/useCartao'
import { useComprovante } from 'modules/pagamentos/hooks/useComprovante'

interface ComprovanteRecargaCelularProp {
  protocolo?: string
}
// eslint-disable-next-line react/display-name
const ComprovanteRecargaCelular = React.forwardRef<
  React.ReactElement,
  ComprovanteRecargaCelularProp
>((prop, ref) => {
  const { recargaCelular } = useComprovante()
  const { cartao } = useCartao()

  return (
    <HiddenContainer>
      {isValidValue(recargaCelular) && (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Container ref={ref}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  textAlign: 'center',
                }}
              >
                <Grid item xs={12}>
                  <img src={logoTmovPay} height={40} />
                </Grid>
                <Grid item xs={12}>
                  <TextBoleto
                    $fontSize={'18px'}
                    $fontWeight={'700'}
                    $color={colors.gray1}
                  >
                    Comprovante de recarga de celular
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'14px'}
                    $fontWeight={'400'}
                    $color={colors.gray}
                  >
                    {format(new Date(), 'dd/MM/yyyy H:mm:ss')}
                  </TextBoleto>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  margin: 16,
                }}
              >
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Detalhes
                    </TextBoleto>
                  </Grid>
                </Box>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Operadora
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {`${recargaCelular?.operadora?.descricao}`}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Número de celular
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {`${recargaCelular?.ddd} ${recargaCelular?.telefone}`}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Data
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {format(new Date(), 'dd/MM/yyyy')}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Valor da recarga
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(recargaCelular?.valor ?? 0)}
                  </TextBoleto>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Conta debitada
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Nome
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao.titular}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      {isValidValue(cartao?.conta) ? 'Conta' : 'Cartão'}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao?.conta ?? cartao?.identificador}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Meio de pagamento
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      TMOV Pay
                    </TextBoleto>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </HiddenContainer>
  )
})

export default ComprovanteRecargaCelular
